import { AccountState } from '../../types/accounts/accounts.types';
import {
  AccountActionTypes,
  GET_ACCOUNT_REQUEST,
  GET_ACCOUNT_SUCCESS,
  GET_ACCOUNT_FAILURE,
  INVITE_USER_TO_ACCOUNT_REQUEST,
  INVITE_USER_TO_ACCOUNT_SUCCESS,
  INVITE_USER_TO_ACCOUNT_FAILURE,
  CLEAR_ACCOUNT_STATE,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILURE,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAILURE,
} from './accounts.types';

const initialState: AccountState = {
  account: null,
  loading: false,
  error: null,
  inviteUserLoading: false,
  inviteUserError: null,
  inviteUserSuccess: null,
  deleteUserLoading: false,
  deleteUserError: null,
  deleteUserSuccess: null,
  updateUserLoading: false,
  updateUserError: null,
  updateUserSuccess: null,
};

const accountsReducer = (
  state = initialState,
  action: AccountActionTypes
): AccountState => {
  switch (action.type) {
    case GET_ACCOUNT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_ACCOUNT_SUCCESS:
      return {
        ...state,
        loading: false,
        account: action.payload.account,
        error: null,
      };

    case GET_ACCOUNT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case INVITE_USER_TO_ACCOUNT_REQUEST:
      return {
        ...state,
        inviteUserLoading: true,
        inviteUserError: null,
        inviteUserSuccess: null,
      };

    case INVITE_USER_TO_ACCOUNT_SUCCESS:
      return {
        ...state,
        inviteUserLoading: false,
        inviteUserSuccess: action.payload,
        inviteUserError: null,
      };

    case INVITE_USER_TO_ACCOUNT_FAILURE:
      return {
        ...state,
        inviteUserLoading: false,
        inviteUserError: action.payload,
        inviteUserSuccess: null,
      };

    case CLEAR_ACCOUNT_STATE:
      return {
        ...state,
        error: null,
        inviteUserError: null,
        deleteUserError: null,
        updateUserError: null,
        inviteUserSuccess: null,
        deleteUserSuccess: null,
        updateUserSuccess: null,
      };

    case DELETE_USER_REQUEST:
      return {
        ...state,
        deleteUserLoading: true,
        deleteUserError: null,
        deleteUserSuccess: null,
      };

    case DELETE_USER_SUCCESS:
      return {
        ...state,
        deleteUserLoading: false,
        deleteUserSuccess: action.payload,
        deleteUserError: null,
      };

    case DELETE_USER_FAILURE:
      return {
        ...state,
        deleteUserLoading: false,
        deleteUserError: action.payload,
        deleteUserSuccess: null,
      };

    case UPDATE_USER_REQUEST:
      return {
        ...state,
        updateUserLoading: true,
        updateUserError: null,
        updateUserSuccess: null,
      };

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        updateUserLoading: false,
        updateUserSuccess: action.payload,
        updateUserError: null,
      };

    case UPDATE_USER_FAILURE:
      return {
        ...state,
        updateUserLoading: false,
        updateUserError: action.payload,
        updateUserSuccess: null,
      };

    default:
      return state;
  }
};

export default accountsReducer;
